
export const environment = {
  production: true,
  name: "Production",

  auth0: {
    domain: 'login.transnetyx.com',
    clientId: 'GaDHAkD7joAAhaZZfQMByQvaZppbqJSz',
    audience: 'BioSeq_Api',
    scope: 'BioSeq',
    redirectUri: `https://bioseq.transnetyx.com`
  },

  apiUrl: "https://api.transnetyx.com/bioseq/"
};
